import React from "react";
import StyledATag from "./small-styled-a-tag";

const UsefulLinks = () => {
  return (
    <div>
      <h3 className="text-2xl font-bold font-title">Useful Links</h3>
      <ul>
        {[
          { href: "https://elixir-lang.org", text: "Elixir Language" },
          { href: "https://elm-lang.org", text: "Elm Language" },
          {
            href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
            text: "JavaScript @ MDN",
          },
          {
            href: "https://pragprog.com/book/elixir16/programming-elixir-1-6",
            text: "Programming Elixir on PragPrag",
          },
          { href: "https://pragmaticstudio.com", text: "Pragmatic Studio" },
        ].map(({ href, text }) => (
          <li key={href}>
            <StyledATag href={href}>{text}</StyledATag>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UsefulLinks;
